export const urls = {
  GET_ZAHTEVE: 'DokServisniZahtevi/vrati_dok_servisne_zahteve_za_masinu',
  GET_RADNI_NALOG_ZA_ID: 'DokRNServisni/vrati_dok_rn_servisni_za_id',
  GET_PONUDE_ID: 'DokPonude/vrati_dok_ponude_za_id',
};
